import {Inject, Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {AuthenticationService} from "../authentication.service";

/// This class prevents someone from loading the login page if they are
/// already logged in.

@Injectable()
export class LoginGuard implements CanActivate {

    constructor(private router: Router, private authService : AuthenticationService) {
    }

    canActivate() {
        if (this.authService.currentUser() == null) {
            return true;
        }

        // Already logged in? Head to the dashboard page.
        this.router.navigate(['/']);
        return false;
    }
}